import { createFileRoute } from "@tanstack/react-router";

import { ProductsPage } from "../../../../features/catalog/products-page";

export const Route = createFileRoute("/_app/catalog/products/")({ component: ProductsPage });
